import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RadioGroup, Radio, FormControl, FormControlLabel, TextField, Icon, Tooltip } from '@material-ui/core';
import { modalNext, modalBack, codeInputChanged, displayTypeChanged, startAppleTVMode } from '../../../actions/TVModeAction';

class TVModeModalDisplayOptionsComponent extends Component{

  renderInput(){
    if (this.props.displayType === 'onAppleTV'){
      return (
        <div>
          <TextField
            style={{ width: 200 }}
            className="text-field-input"
            id="TVModeKey"
            label="Enter 5-character code"
            inputProps={{ maxLength: 5, style: { textTransform: 'uppercase' } }}
            onChange={e => this.props.codeInputChanged(e.target.value)}
            value={this.props.codeText}
            onKeyPress={this.checkEnter.bind(this)}
          />
          {this.renderConfirmation()}
          {this.renderMessage()}
        </div>
      );
    }
  }

  checkEnter(e){
    if (this.props.codeText.length === 5){
      if (e.key === 'Enter'){
        e.preventDefault();
        this.props.startAppleTVMode();
      }
    }
  }

  renderConfirmation(){
    if (this.props.connection === 'success'){
      return ( <div> <Icon className="tv-success">check</Icon> </div> );
    } else if (this.props.connection === 'fail'){
      return ( <div> <Icon className="tv-fail">close</Icon></div> );
    }
  }

  renderMessage(){
    if (this.props.connection === 'success'){
      return (<div className="tv-code-valid">Code Sent!</div>);
    } else if (this.props.connection === 'fail'){
      return (<div className="tv-code-error">Could not connect to Apple TV</div>);
    }
  }

  render(){
    const tooltipText = (
      <div style={{ width: 184 }}>
        <div style={{ marginBottom: 10, fontSize: 12, fontFamily: "Montserrat" }}>
          Download the Prism app on your Apple TV.
        </div>
        <div style={{ fontSize: 12, fontFamily: "Montserrat" }}>
          When you launch it, you will see a code that you can use to display your Shoutout Reel.
        </div>
      </div>
    );

    return (
      <div style = {{ paddingTop: 15, paddingLeft: 40, paddingBottom: 20 }}>
        <div className="display-selection" style={{ height: '100%' }}>
          <FormControl component="fieldset" >
            <RadioGroup
              name="displayOptions"
              onChange= {e => this.props.displayTypeChanged(e.target.value)}
              value={this.props.displayType}
            >
              <FormControlLabel
                value="onDevice"
                className="form-control-label"
                control= { <Radio /> }
                label="Display on this device"
              />

              <FormControlLabel
                value="onAppleTV"
                className="form-control-label"
                control= { <Radio /> }
                label="Display on Apple TV"
              />

              <Tooltip
                className="modal-tooltip"
                placement="right-start"
                title={tooltipText}>
                <Icon>help</Icon>
              </Tooltip>

            </RadioGroup>
          </FormControl>
        </div>
        {this.renderInput()}
      </div>
    );
  }
}

const mapStateToProps = ({ tvModeStore })=> {
  const { codeText, displayType, connection  } = tvModeStore;
  return { codeText, displayType, connection };
};


const TVModeModalDisplayOptions = connect(mapStateToProps, {
  modalNext,
  modalBack,
  codeInputChanged,
  displayTypeChanged,
  startAppleTVMode
})(TVModeModalDisplayOptionsComponent);
export { TVModeModalDisplayOptions };


// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModalSections/TVModeModalDisplayOptions.js